
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import SEO from '@/components/seo/SEO';

const LegalNotice: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-b from-golf-50 to-white">
      <SEO
        title="Mentions légales — Golf Progress Calculator"
        description="Mentions légales de Golf Progress Calculator : éditeur, hébergeur et informations légales de l'application."
        path="/legal"
      />
      <div className="container mx-auto py-8 px-4">
        <div className="mb-6">
          <Button variant="ghost" onClick={() => navigate('/')} className="mb-4">
            <ArrowLeft className="h-4 w-4 mr-2" />
            {t('buttons.back')}
          </Button>
        </div>

        <Card className="max-w-4xl mx-auto">
          <CardHeader>
            <CardTitle className="text-2xl">{t('legalNotice.title')}</CardTitle>
          </CardHeader>
          <CardContent className="prose max-w-none">
            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">{t('legalNotice.publisher.title')}</h2>
              <div className="space-y-2">
                <p><strong>{t('legalNotice.publisher.companyName')}</strong> {t('legalNotice.publisher.companyValue')}</p>
                <p><strong>{t('legalNotice.publisher.address')}</strong> {t('legalNotice.publisher.addressValue')}</p>
                <p><strong>{t('legalNotice.publisher.email')}</strong> {t('legalNotice.publisher.emailValue')}</p>
                <p><strong>{t('legalNotice.publisher.director')}</strong> {t('legalNotice.publisher.directorValue')}</p>
              </div>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">{t('legalNotice.hosting.title')}</h2>
              <div className="space-y-2">
                <p><strong>{t('legalNotice.hosting.host')}</strong> {t('legalNotice.hosting.hostValue')}</p>
                <p><strong>{t('legalNotice.hosting.address')}</strong> {t('legalNotice.hosting.addressValue')}</p>
                <p><strong>{t('legalNotice.hosting.website')}</strong> <a href="https://supabase.com" className="text-blue-600 hover:underline">https://supabase.com</a></p>
              </div>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">{t('legalNotice.intellectualProperty.title')}</h2>
              <p className="mb-3">
                {t('legalNotice.intellectualProperty.content')}
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">{t('legalNotice.personalData.title')}</h2>
              <p className="mb-3">
                {t('legalNotice.personalData.content')}
              </p>
              <p className="text-sm text-gray-600">
                {t('legalNotice.personalData.contact')}
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">{t('legalNotice.responsibility.title')}</h2>
              <p className="mb-3">
                {t('legalNotice.responsibility.content')}
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">{t('legalNotice.hyperlinks.title')}</h2>
              <p className="mb-3">
                {t('legalNotice.hyperlinks.content')}
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default LegalNotice;
